import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    es: {
        translation: {
          NO_MORE_QUESTIONS: "No tienes mas preguntas por responder",
          GO_BACK_RAPPI: "Volver a Rappi",
          THANKS_FOR_SHARE: "Gracias por compartir",
          EXCEDE_CHARACTERS: "¡Opps! Excediste el número de caracteres",
          YOU_HAVE_RECEIVED: "Has recibido"
        }
    },
    br: {
        translation: {
          NO_MORE_QUESTIONS: "Você não tem mais perguntas para responder",
          GO_BACK_RAPPI: "Voltar para rappi",
          THANKS_FOR_SHARE: "Obrigado por compartilhar",
          EXCEDE_CHARACTERS: "Opps! Você excedeu o número de caracteres",
          YOU_HAVE_RECEIVED: "Recebeu"
        },
    },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "es",
    fallbackLng: "es", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;